import styled from '@emotion/styled'
import { AppBar } from '@mui/material'

const BaseAppBar = styled(AppBar)`
  position: relative;
  box-shadow: none;
  background-color: transparent;
`

export default BaseAppBar
